import { Controller } from "@hotwired/stimulus";
import "react_ujs";

export default class extends Controller {
  static targets = ["productSelect"];
  static values = {
    gutterItemId: String,
    estimateId: String,
    latestColor: String,
    duplicate: Boolean,
  };

  initialize() {
    const checkedRadio = this.productSelectTargets.find(
      (radio) => radio.checked
    );
    if (checkedRadio) {
      this.loadOptionsWithValue(checkedRadio.value);
    }
  }

  loadOptions(event) {
    const productId = event.target.value;
    this.loadOptionsWithValue(productId);
  }

  loadOptionsWithValue(productId) {
    if (productId) {
      const optionsFrame = document.getElementById("gutter_options");
      const params = new URLSearchParams();

      if (this.gutterItemIdValue) {
        params.append("gutter_item_id", this.gutterItemIdValue);
      }

      if (this.estimateIdValue) {
        params.append("estimate_id", this.estimateIdValue);
      }

      if (this.latestColorValue) {
        params.append("latest_color", this.latestColorValue);
      }

      if (this.duplicateValue) {
        params.append("duplicate", "true");
      }

      optionsFrame.src = `/sales/gutter_products/${productId}/options?${params.toString()}`;

      // Reinitialize React components after Turbo frame loads
      optionsFrame.addEventListener(
        "turbo:frame-load",
        this.initializeReactComponents,
        { once: true }
      );
    }
  }

  initializeReactComponents() {
    ReactRailsUJS.handleMount();
  }
}
